export default __webpack_public_path__ + "static/media/Utility.2dc2d636.jpeg";